export default "__VITE_ASSET__TL_3GJMB__"